var map = {
	"./ACHARJYA PHARMACY_logo_prev_ui.png": 1470,
	"./BUILDNSPACE CONSTRUCTION_FF2.png": 2470,
	"./BiryanI.png": 7519,
	"./CAMELIA_GROUP_OF_SCHOOL_LOGO_REDESIGN-1_prev_ui.png": 6966,
	"./Career_30Logo_white_prev_ui.png": 1969,
	"./Cha_Ta_Logo_white.png": 1959,
	"./Chandrani.png": 3029,
	"./Chung.png": 4137,
	"./Chunw.png": 8156,
	"./Cloudempire_Logo_prev_ui.png": 5352,
	"./Dr Bedanka Roy_logo_prev_ui.png": 2262,
	"./Gift studio_Logo_prev_ui.png": 5512,
	"./Ivory_Dental.png": 7252,
	"./KIS.png": 5906,
	"./LBC LOGO_JPG_prev_ui.png": 4743,
	"./Mom_Chocolate.png": 9429,
	"./Prospect_Logo.png": 2584,
	"./Sai_Dental.png": 3299,
	"./Spot Boyz_Logo_recolor_prev_ui (1).png": 6177,
	"./Tamrolipto_College_Of_Medical_Sciencee_Logo_WHITE_prev_ui.png": 6077,
	"./adobeillustrator.png": 8747,
	"./adobephotoshop.png": 9969,
	"./adobleexpress.png": 6613,
	"./adwords.png": 8585,
	"./affinitydesigner.png": 1875,
	"./ahrefs.png": 2282,
	"./android.png": 805,
	"./angular.png": 6573,
	"./animatrix.png": 6646,
	"./appdevelopment.png": 6159,
	"./appdevelopment1.png": 2323,
	"./apple.png": 6278,
	"./as.png": 7429,
	"./aswamedh.png": 6875,
	"./atom.png": 9495,
	"./aws.png": 686,
	"./bootstrap.png": 5077,
	"./buzzsumo.png": 9622,
	"./cafecheers.png": 929,
	"./canva.png": 3064,
	"./drupal.png": 3379,
	"./elasticsearch.png": 6279,
	"./elixir.png": 9213,
	"./emberjs.png": 1225,
	"./figma.png": 2582,
	"./flutter.png": 4997,
	"./future.png": 9012,
	"./gimp.png": 5026,
	"./gkp.png": 8964,
	"./googleanalytics.png": 1760,
	"./graphicdesign.png": 4488,
	"./graphql.png": 2471,
	"./hubspot.png": 1229,
	"./image4.png": 3947,
	"./inkscape.png": 105,
	"./krita.png": 1898,
	"./logo.png": 2794,
	"./mysql.png": 5952,
	"./net.png": 8325,
	"./node.png": 4313,
	"./our-client.png": 6189,
	"./ourClientslogo1.png": 4185,
	"./ourClientslogo2.png": 3551,
	"./pheonix.png": 8562,
	"./phoenix.png": 6230,
	"./php.png": 4378,
	"./profile.png": 6042,
	"./proofhub.png": 5245,
	"./react.png": 4010,
	"./redis.png": 5639,
	"./rubyrails.png": 2852,
	"./search-engine-optimization.png": 8759,
	"./semrush.png": 2660,
	"./sketch.png": 103,
	"./socialmedia1.png": 7628,
	"./technology.png": 1353,
	"./telephone.png": 2641,
	"./unsplash.png": 3960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 414;